import React, { Component } from 'react'
import { Button } from '@material-ui/core';

class ListItem extends Component {


	state = {
		added: false
	}

	render() {
		const { id, logo, name, alt } = this.props.item;
		const { add, remove } = this.props;

		const toggleAdd = () => {
			this.state.added ? remove(id) : add(id);

			this.setState({
				added: !this.state.added
			})

		}

		return (

			<li>
				<div className="nav-list-left">
					<div className="logo">
						<img src={logo} alt={alt} />
					</div>
					<p>{name}</p>
				</div>

				<Button
					className=""

					variant={this.state.added ? "outlined" : "contained"}

					color={this.state.added ? "secondary" : "primary"}

					onClick={toggleAdd}>

					{this.state.added ? "X" : "Add"}
				</Button>

			</li>

		)
	}

}

export default ListItem


// WEBPACK FOOTER //
// ./src/components/Nav/ListItem.jsx